import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const DEFAULT_DASHBOARD_FONT = 'inter';
export const DEFAULT_DASHBOARD_FONT_WEIGHT = 'regular';

export const DASHBOARD_FONT_WEIGHT_OPTIONS = [
  { key: 'light', label: 'Light', value: 300 },
  { key: 'regular', label: 'Regular', value: 400 },
  { key: 'medium', label: 'Medium', value: 500 },
];

export const DASHBOARD_FONT_OPTIONS = [
  {
    key: 'inter',
    label: 'Inter',
    description: 'Limpa e compacta',
    family: "'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'manrope',
    label: 'Manrope',
    description: 'Moderna e espaçosa',
    family:
      "'Manrope Variable', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'funnel-display',
    label: 'Funnel Display',
    description: 'Expressiva e contemporânea',
    family:
      "'Funnel Display', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'plus-jakarta-sans',
    label: 'Plus Jakarta Sans',
    description: 'Elegante e contemporânea',
    family:
      "'Plus Jakarta Sans Variable', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'dm-sans',
    label: 'DM Sans',
    description: 'Leve e muito legível',
    family:
      "'DM Sans Variable', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'poppins',
    label: 'Poppins',
    description: 'Geométrica e marcante',
    family:
      "'Poppins', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'geist',
    label: 'Geist',
    description: 'Moderna e objetiva',
    family:
      "'Geist Variable', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },
  {
    key: 'jetbrains-mono',
    label: 'JetBrains Mono',
    description: 'Monoespaçada e técnica',
    family:
      "'JetBrains Mono Variable', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  },
  {
    key: 'system',
    label: 'Do dispositivo',
    description: 'A fonte nativa do sistema',
    family:
      "-apple-system, BlinkMacSystemFont, system-ui, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
];

export const normalizeDashboardFont = font =>
  DASHBOARD_FONT_OPTIONS.some(option => option.key === font)
    ? font
    : DEFAULT_DASHBOARD_FONT;

export const normalizeDashboardFontWeight = weight =>
  DASHBOARD_FONT_WEIGHT_OPTIONS.some(option => option.key === weight)
    ? weight
    : DEFAULT_DASHBOARD_FONT_WEIGHT;

export const setDashboardFont = font => {
  const normalizedFont = normalizeDashboardFont(font);
  const option = DASHBOARD_FONT_OPTIONS.find(
    item => item.key === normalizedFont
  );

  document.documentElement.style.setProperty(
    '--dashboard-font-family',
    option.family
  );
  document.documentElement.dataset.dashboardFont = normalizedFont;
  LocalStorage.set(LOCAL_STORAGE_KEYS.DASHBOARD_FONT, normalizedFont);

  return normalizedFont;
};

export const initializeDashboardFont = preferredFont =>
  setDashboardFont(
    preferredFont ||
      LocalStorage.get(LOCAL_STORAGE_KEYS.DASHBOARD_FONT) ||
      DEFAULT_DASHBOARD_FONT
  );

export const setDashboardFontWeight = weight => {
  const normalizedWeight = normalizeDashboardFontWeight(weight);
  const option = DASHBOARD_FONT_WEIGHT_OPTIONS.find(
    item => item.key === normalizedWeight
  );

  document.documentElement.style.setProperty(
    '--dashboard-font-weight',
    String(option.value)
  );
  document.documentElement.dataset.dashboardFontWeight = normalizedWeight;
  LocalStorage.set(LOCAL_STORAGE_KEYS.DASHBOARD_FONT_WEIGHT, normalizedWeight);

  return normalizedWeight;
};

export const initializeDashboardFontWeight = preferredWeight =>
  setDashboardFontWeight(
    preferredWeight ||
      LocalStorage.get(LOCAL_STORAGE_KEYS.DASHBOARD_FONT_WEIGHT) ||
      DEFAULT_DASHBOARD_FONT_WEIGHT
  );
